

import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Home from './Home';
// import Blogs from '../Blogs/Blogs';
import Banner from './Banner/Banner';
import ThreeSteps from './ThreeSteps/ThreeSteps';
import Referrals from './Referrals/Referrals';
import Offers from './Offers/Offers';
import Faqs from './Faqs/Faqs';
import FinancialConsultant from './FinancialConsultant/FinancialConsultant';
import AppLinkHeading from './AppLink/AppLinkHeading';
import AppLink from './AppLink/AppLink';
import BannerHome from './Banner/BannerTabComponents/BannerHome';
import OffersSection from './Offers/OffersSection';
import ThreeStepsSection from './ThreeSteps/ThreeStepsSection';
import ReferralsSection from './Referrals/ReferralsSection';
import FinancialConsultantSection from './FinancialConsultant/FinancialConsultantSection';
import AppLinkSection from './AppLink/AppLinkSection';
import FaqsSection from './Faqs/FaqsSection';

function ContentManagement() {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const renderTabContent = () => {
        switch (value) {
            case 0:
                return <BannerHome />;
            case 1:
                return <OffersSection />;
            case 2:
                return <ThreeStepsSection />;
            case 3:
                return <ReferralsSection />;

            case 4:
                return <FinancialConsultantSection />; 
            case 5:
                return <AppLinkSection />;
            case 6:
                return <FaqsSection />;


            default:
                return null;
        }
    };

    return (
        <div>
            <Box
                sx={{
                    maxWidth: { xs: 320, sm: "100%", md: "100%" },
                    bgcolor: 'background.paper', color: "#C38F51", p: 1
                }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    aria-label="scrollable auto tabs example"
                    sx={{ '.MuiButtonBase-root-MuiTab-root.Mui-selected ': { color: "#C38F51" } }}
                    TabIndicatorProps={{
                        style: {
                            mt: 0,

                            backgroundColor: '#C38F51',
                            height: '3px', // Adjust the thickness of the bottom border
                        },
                    }}
                >
                    {['Banner', 'Offers', '3 Steps', 'Referrals', "Financial Consultant", "App Link", 'Faqs'].map(
                        (label, index) => (
                            <Tab
                                key={label}
                                label={label}
                                sx={{
                                    '.MuiButtonBase-root-MuiTab-root.Mui-selected ': { color: "#C38F51" },
                                    fontSize: "16px",
                                    color: value === index ? '#C38F51' : 'black',
                                    textTransform: 'none',
                                    fontWeight: value === index ? 'bold' : 'normal',
                                    borderBottom:
                                        value === index ? '3px solid #C38F51' : 'none',
                                    // minWidth: 100, // Ensures tabs have a minimum width  transition: 'color 0.3s ease', // Smooth transition for color change
                                    '&.Mui-selected': {
                                        color: '#C38F51', // Ensures proper application for the selected tab
                                    },
                                    '&:hover': {
                                        color: '#C38F51', // Hover effect for unselected tabs
                                    },
                                }}
                            />
                        )
                    )}
                </Tabs>
            </Box>
            <Box sx={{ py: 2 }}>{renderTabContent()}</Box>
        </div >
    );
}

export default ContentManagement;
